import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LookupModel, TextToSpeechResponse } from '../../api/models';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { NotificationService } from '../../notification/notification.service';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormHelpers } from '../../core/utilities/form-helpers';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatTextareaInputComponent } from '../../editors/mat-textarea-input/mat-textarea-input.component';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { LocalPbxService } from '../../pbx/local-pbx.service';

export interface TextToSpeechDialogData {}

@Component({
  selector: 'app-text-to-speech-dialog',
  templateUrl: './text-to-speech-dialog.component.html',
  standalone: true,
  imports: [
    FlexModule,
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatSimpleSelectComponent,
    MatTextareaInputComponent,
    MatButton,
    Angular2PromiseButtonModule,
    MatDialogActions,
  ],
  styles: ['.stretched-container {overflow: auto;}'],
})
export class TextToSpeechDialogComponent implements OnInit, OnDestroy {
  form: FormGroup;
  languageControl = new FormControl('en-US', [Validators.required]);
  voiceControl = new FormControl('', [Validators.required]);
  textControl = new FormControl('', [Validators.required]);
  languages: LookupModel[] = [{ id: 'en-US', text: 'English' }];
  voices: LookupModel[] = [];

  buttonPreviewPromise: Promise<void>;

  @ViewChild('audioPreview') audioPreview: ElementRef;
  textToSpeechData: TextToSpeechResponse;
  submitted = false;

  constructor(
    public dialogRef: MatDialogRef<TextToSpeechDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TextToSpeechDialogData,
    public pbxService: LocalPbxService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this.form = this.fb.group({
      text: this.textControl,
      voice: this.voiceControl,
      language: this.languageControl,
    });

    this.asyncOnInit().then();
  }

  public ngOnDestroy(): void {}

  public onPreviewClick(autoPlay: boolean, autoSubmit: boolean): void {
    if (this.form.valid) {
      this.buttonPreviewPromise = this.requestAudio(autoPlay, autoSubmit);
    }
  }

  public onSubmit(): void {
    FormHelpers.forceValidate(this.form);
    if (this.form.valid) {
      this.submitted = true;

      if (!this.textToSpeechData?.base64) {
        this.onPreviewClick(false, true);
      } else {
        this.asyncSubmit().then();
      }
    }
  }

  private async asyncOnInit(): Promise<void> {
    this.voices = await this.pbxService.getTextToSpeechVoices();
  }

  private async requestAudio(autoPlay: boolean, autoSubmit: boolean): Promise<void> {
    const reqData = this.prepareFormModel();
    this.textToSpeechData = await this.pbxService.getGeneratedHolidayGreeting(reqData);

    const audio: HTMLAudioElement = this.audioPreview.nativeElement;

    audio.src = `data:${this.textToSpeechData.mimeType};base64,${this.textToSpeechData.base64}`;

    if (autoPlay) {
      await audio.play();
    }

    if (autoSubmit) {
      await this.asyncSubmit();
    }
  }

  private prepareFormModel(): any {
    const formModel = this.form.getRawValue();

    const fileData = undefined;

    console.log(fileData);

    return {
      text: formModel.text,
      language: formModel.language,
      voiceName: formModel.voice,
    };
  }

  private async asyncSubmit(): Promise<void> {
    this.submitted = false;

    if (this.textToSpeechData?.base64) {
      this.dialogRef.close(this.textToSpeechData);
    } else {
      this.notificationService.notifyDanger('No text to speech data available. Please generate it first.');
    }
  }
}
